import { formatterPath } from '@/helpers/navigation';
import {
  NEWLINE,
  RECONTRACT,
  RRP_EQUIPMENT,
  RRP_ACCESSORY,
  NUMBER_SHARE,
  CHECK_ELIGIBILITY,
  RESERVE_NUMBER,
  CATALOGUE,
  BUY_ADD_ONS,
  TERMINATE_NUMBER,
  CEASE_ADDONS,
  CHANGE_PLAN,
  REPLACE_SIM,
  ACTIVATE_SIM,
  SER_ROADSHOW,
  STAFF_CHECK_ELIGIBILITY,
  NUMBER_PORT,
  REPORT_LOST,
  CHANGE_MOBILE_NUMBER,
  TRANSFER_MOBILE_LINE,
  GET_ESIM_ACTIVATION_CODE,
  SUSPEND_LINE,
  UNSUSPEND_LINE,
  REFIT_LINE
} from '@/config/common';
import paths from '@/helpers/navigation/paths.json';
import { userPolicyFeatureCode } from './userGroupPolicy';

export const EVENT_MENU_CLICK = 'EVENT_MENU_CLICK';

export const EVENT_MODAL_NAVIGATION = 'EVENT_MODAL_NAVIGATION';

export const PREVENT_NAVIGATE_LIST = [paths.ORDER_REVIEW.url];

export const HOME_MENU = [
  {
    name: 'purchase',
    image: '//cdn2.singteldigital.com/content/dam/singtel/online-draft/singtel-com/homemarketing1.jpg',
    items: [
      {
        header: 'Purchase',
        list: [
          {
            title: 'New Line',
            url: '/order/priceplan',
            orderType: NEWLINE
          },
          {
            title: 'Phones',
            url: '/order/equipment',
            orderType: RRP_EQUIPMENT
          },
          {
            title: 'Accessories',
            url: '/order/equipment',
            orderType: RRP_ACCESSORY
          },
          {
            title: 'Add-ons',
            url: '/buyaddons',
            orderType: BUY_ADD_ONS
          },
          {
            title: 'NumberShare',
            url: '/numbershare',
            orderType: NUMBER_SHARE
          },
          {
            title: 'SER Roadshow',
            url: '/serroadshow',
            orderType: SER_ROADSHOW
          }
        ]
      }
    ]
  },
  {
    name: 'services',
    image: '//cdn2.singteldigital.com/content/dam/singtel/online-draft/singtel-com/homemarketing8.jpg',
    items: [
      {
        header: 'Manage Services',
        list: [
          {
            title: 'Recontract',
            url: '/order/contract',
            orderType: RECONTRACT
          },
          {
            title: 'Check Eligibility',
            url: '/checkeligibility',
            orderType: CHECK_ELIGIBILITY
          },
          {
            title: 'Reserve Number',
            url: '/reservenumber',
            orderType: RESERVE_NUMBER
          },
          {
            title: 'Cease Add-ons',
            url: '/ceaseaddons',
            orderType: CEASE_ADDONS
          },
          {
            title: 'SIM Activation',
            url: '/simactivation',
            orderType: ACTIVATE_SIM
          },
          {
            title: 'Catalogue',
            url: '/catalogue',
            orderType: CATALOGUE
          },
          {
            title: 'Terminate Number',
            url: '/terminatenumber',
            orderType: TERMINATE_NUMBER
          },
          {
            title: 'Change Plan',
            url: '/changeplan',
            orderType: CHANGE_PLAN
          },
          {
            title: 'Replace Sim Card',
            url: '/replacesim',
            orderType: REPLACE_SIM
          },
          {
            title: 'Transfer Mobile Lines',
            url: '/transfermobileline',
            orderType: TRANSFER_MOBILE_LINE
          },
          {
            title: 'Report Lost',
            url: '/reportlost',
            orderType: REPORT_LOST
          },
          {
            title: 'Staff-Plan Eligibility',
            url: '/staffplaneligibility',
            orderType: STAFF_CHECK_ELIGIBILITY
          },
          {
            title: 'Number Port',
            url: '/numberport',
            orderType: NUMBER_PORT
          },
          {
            title: 'Change Mobile Number',
            url: '/changemobilenumber',
            orderType: CHANGE_MOBILE_NUMBER
          },
          {
            title: 'Retrieve eSIM Activation code',
            url: '/simactivation/esim',
            orderType: GET_ESIM_ACTIVATION_CODE
          },
          {
            title: 'Suspend Line',
            url: '/suspendline',
            orderType: SUSPEND_LINE
          },
          {
            title: 'Un-Suspend Line',
            url: '/unsuspendline',
            orderType: UNSUSPEND_LINE
          },
          {
            title: 'Refit Line',
            url: '/refitline',
            orderType: REFIT_LINE
          }

        ]
      }
    ]
  },
  {
    name: 'billing',
    image: '//cdn2.singteldigital.com/content/dam/singtel/CorporateAQ4I5439-1.jpg',
    items: [
      {
        header: 'Billing',
        list: [
          {
            title: 'View Billing Statements',
            url: '',
            orderType: ''
          }
        ]
      },
      {
        header: 'Analytics',
        list: [
          {
            title: 'View Transaction History',
            url: '/account/transactionhistory?statusIndex=0&pageNo=1',
            orderType: ''
          }
        ]
      },
      {
        header: 'Smart Template',
        list: []
      },
      {
        header: 'eForm',
        list: []
      }

    ]
  }
];

enum featureKey {
  profile = 'profile',
  brnaccount = 'brnaccount',
  transactionhistory = 'transactionhistory',
  account = 'account',
  userAccessManagement = 'userAccessManagement',
  changeuserdetails = 'changeuserdetails',
  permissionPolicies = 'permissionPolicies',
  groupsPolicies = 'groupsPolicies',
  usersPolicies = 'usersPolicies',
  address = 'address',
  billingaccount = 'billingaccount',
  transactionapproval = 'transactionapproval'
}

export const menuData = [
  {
    name: 'My Account',
    path: featureKey.account,
    children: [
      {
        name: 'Profile',
        path: featureKey.profile,
        key: featureKey.profile
      },
      {
        name: 'BRN & CES Account',
        path: featureKey.brnaccount,
        key: featureKey.brnaccount
      },
      {
        name: 'Transaction History',
        path: featureKey.transactionhistory,
        key: featureKey.transactionhistory,
        permissionKey: userPolicyFeatureCode.MOBI_ORDER_STATUS,
        children: [
          {
            name: 'Transaction Approval',
            path: featureKey.transactionapproval,
            key: featureKey.transactionapproval,
            permissionKey: userPolicyFeatureCode.MOBI_ORDER_STATUS
          }
        ]
      },
      {
        name: 'Change User Details',
        path: featureKey.changeuserdetails,
        key: featureKey.changeuserdetails,
        permissionKey: userPolicyFeatureCode.CHANGE_USERNAME
      },
      {
        name: 'Address',
        path: featureKey.address,
        key: featureKey.address,
        permissionKey: [userPolicyFeatureCode.OFFICE_DEL, userPolicyFeatureCode.RESI_ADDR]
      }
    ]
  },
  // {
  //   name: 'Notification',
  //   path: featureKey.account
  // },
  {
    name: 'Billing Account Settings',
    path: featureKey.account,
    children: [
      {
        name: 'Billing Account',
        path: featureKey.billingaccount,
        key: featureKey.billingaccount,
        permissionKey: userPolicyFeatureCode.CHANGE_BIL_ADDR
      }
    ]
  },
  // {
  //   name: 'User Access Management',
  //   path: featureKey.account,
  //   children: [
  //     //   {
  //     //     name: 'Permission Settings',
  //     //     path: 'permissionSettings',
  //     //     key: 'permissionSettings'
  //     //   }
  //   ]
  // }
];

export const getMenuData = () => formatterPath(menuData);
